<m-icon class="m-icon-file"
        :name="spriteId"
        :svgTitle="svgTitle"
        :size="size"
        @click="onClick"
        @keydown="onKeydown"></m-icon>
